module.exports = __webpack_public_path__ + "media/images/ow-bonus-kv-45896f5b90ad186b63d69ecf4f21c4a8.png";